import React from 'react';
import { dynaMount } from '../utils/mountComponent';
import { RSVPLabel, RSVPOptions, RSVPOptionsProps } from './RSVP';
import './RSVP.scss';

export const RSVP_LABEL_ROOT_ID = 'listings-root__rsvp-label';
export const RSVP_ROOT_ID = 'listings-root__rsvp';
export const RSVP_STICKY_LABEL_ROOT_ID = 'listings-root__rsvp-sticky-label';

const RSVPOptionsMount = (
    rsvpProps: RSVPOptionsProps,
): JSX.Element | React.ReactPortal => {
    return dynaMount(
        {
            Component: RSVPOptions,
            containerId: RSVP_ROOT_ID,
        },
        rsvpProps,
    );
};

const RSVPLabelMount = () => {
    return dynaMount(
        {
            Component: RSVPLabel,
            containerId: RSVP_LABEL_ROOT_ID,
        },
        {},
    );
};

const RSVPStickyLabelMount = () => {
    return dynaMount(
        {
            Component: RSVPLabel,
            containerId: RSVP_STICKY_LABEL_ROOT_ID,
        },
        {},
    );
};

const RSVPRoot = (props: RSVPOptionsProps) => {
    return (
        <>
            <RSVPOptionsMount {...props} />
            <RSVPLabelMount />
            <RSVPStickyLabelMount />
        </>
    );
};

export default RSVPRoot;
